import { TEdtiorUIState } from './types';

export const initialState: TEdtiorUIState = {
  mouseMouseTooltips: {
    content: null,
  },
};
